import { useMemo } from 'react';
import { create, StoreApi, useStore } from 'zustand';

export enum AnnotationStatusEnum {
  Ready = 'ready',
  Add = 'add',
  Delete = 'delete',
}

export interface AnnotationState {
  annotations: {
    drawEnabled: boolean;
    status: AnnotationStatusEnum;
    currentSelector: string;
  };
}

export interface AnnotationStoreState extends AnnotationState {
  set: StoreApi<AnnotationState>['setState'];
  get: StoreApi<AnnotationState>['getState'];
}

const createAnnotationStore = (initialState?: Partial<AnnotationState>) =>
  create<AnnotationStoreState>((set, get) => ({
    set,
    get,
    annotations: {
      drawEnabled: false,
      status: AnnotationStatusEnum.Ready,
      currentSelector: '',
    },
    ...initialState,
  }));

const store = createAnnotationStore();

export const useAnnotation = () => {
  const state = useStore(store);
  const set = store.getState().set;

  const setStatus = useMemo(
    () =>
      (status: AnnotationStatusEnum, selector: string = '') => {
        set({
          annotations: {
            drawEnabled: status === AnnotationStatusEnum.Add,
            status: status,
            currentSelector: selector,
          },
        });
      },
    [set]
  );

  return { annotations: state.annotations, setStatus };
};
